import React from 'react';
import { connect } from 'react-redux';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';
import { userSignIn, flushAppDetails, fetchTdnSchoologylaunchDetails, isSchoologyAppFalg } from '../redux/actions/Auth';
import getQueryParams from 'util/QueryString';
import { extractClientNameFromURL, getDefaultDomainDetails} from '../util/Extra';
import { setThemeColor } from '../redux/actions/Setting';
import CircularProgress from '@material-ui/core/CircularProgress';


class SchoologyLaunch extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  componentDidMount() {
    const { fetchTdnSchoologylaunchDetails, clientConfigration, isSchoologyAppFalg } = this.props;
    const { serverConfig } = !!clientConfigration && clientConfigration;
    const userCode = getQueryParams(window.location.search, 'code');
    const userEmail = getQueryParams(window.location.search, 'email');
    const username = getQueryParams(window.location.search, 'name');
    const userTypeId = getQueryParams(window.location.search, 'user_type_id');
    const contextId = getQueryParams(window.location.search, 'context_id');
    const schoologyParams = { code: userCode, email: userEmail, name: username, user_type_id: userTypeId, context_id: contextId}
     isSchoologyAppFalg(true);
    if (!isEmpty(userCode) && !isEmpty(serverConfig)) {
      fetchTdnSchoologylaunchDetails(schoologyParams);
    }
  }

  static getDerivedStateFromProps(nextProps) {
    const { signinStatus, history, authUser, userRole, clientConfigration } = nextProps;
    extractClientNameFromURL();
    const { serverConfig } = !!clientConfigration && clientConfigration;

    isEmpty(serverConfig) && history.push('/configration');
    const currentClientFromUrl = sessionStorage.getItem('currentClientFromUrl');
    nextProps.setThemeColor(getDefaultDomainDetails(currentClientFromUrl).themeColor);
    if (authUser !== null && signinStatus && userRole !== null) {
      history.push(`/app/${userRole}`);
    }
    return null;
  }
  render() {
    const { alertMessage, showMessage} = this.props;
    return (
      <div className={`app-container pre-signup-wrapper`}>
        <div className="app-main-container">
          <main className="app-main-content-wrapper email-verification">
            <div className="app-main-content">
              <div className="loader-view">
                <CircularProgress />
              </div>
              {showMessage && NotificationManager.error(alertMessage)}
              <NotificationContainer />
            </div>
          </main>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      userSignIn,
      flushAppDetails,
      fetchTdnSchoologylaunchDetails,
      setThemeColor,
      isSchoologyAppFalg,
    },
    dispatch,
  );
};

const mapStateToProps = ({ auth }) => {
  const { loader, authUser, signinStatus, userRole, clientConfigration, schoologyUserDetails } = auth;
  return {
    loader,
    authUser,
    signinStatus,
    userRole,
    clientConfigration,
    schoologyUserDetails,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SchoologyLaunch);
